import { render, staticRenderFns } from "./ongletsAdministration.vue?vue&type=template&id=ad67b30a&scoped=true"
import script from "./ongletsAdministration.vue?vue&type=script&lang=js"
export * from "./ongletsAdministration.vue?vue&type=script&lang=js"
import style0 from "./ongletsAdministration.vue?vue&type=style&index=0&id=ad67b30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad67b30a",
  null
  
)

export default component.exports